import MetalClient, { BrowserMetricsPlugin, catalog } from '@atlassiansox/metal-client';
import { matchPath } from 'react-router';
import { captureException } from '@atlassian/temp-sentry';
import { addRecordableErrorEventListeners } from '@css-xp/uncaught-error';
import { routePaths } from '@css-xp/ppc-constants';
import { METAL_ENV, PPC_METAL_CLIENT_ID, metalClient } from './client';

export let client: MetalClient | undefined;

const getPage = () => {
  const pageName = Object.keys(routePaths).find((routeKey) =>
    matchPath(window.location.pathname, { path: routePaths[routeKey], exact: true })
  );
  return pageName || 'page-not-found';
};

export const initialize = (): void => {
  addRecordableErrorEventListeners({
    uncaughtError: () => {
      metalClient.metric.submit({
        name: catalog.error.UNCAUGHT,
        page: getPage(),
      });
    },
    unhandledRejection: () => {
      metalClient.metric.submit({
        name: catalog.error.UNHANDLED_PROMISE_REJECTION,
        page: getPage(),
      });
    },
  });

  try {
    client = new MetalClient({
      settings: {
        meta: {
          synthetic: false,
        },
        getPage,
      },
      plugins: [
        new BrowserMetricsPlugin({
          rootId: 'root',
          histograms: {
            [catalog.performance.FIRST_PAINT]: '1000',
            [catalog.performance.FIRST_MEANINGFUL_PAINT]: '1200',
            [catalog.performance.TIME_TO_FIRST_BYTE]: '800',
          },
        }),
      ],
      productInfo: {
        metalId: PPC_METAL_CLIENT_ID,
        env: METAL_ENV,
        version: '1.0.0',
      },
    });
  } catch (e) {
    /* eslint-disable no-console */
    console.error(`Failed to Submit metal Metric ${e}`);
    captureException(e as Error);
  }
};
